/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Player/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import Video from 'DesignSystem/Video/react'



/** @type {import('Simple/types.js').View} */
export default function Player({
  children,
  viewPath = "/DesignSystem/PreviewResource/Content/Content/VideoFile/Player"
  
}) {
let resourcePreviewUrlValueData = fromData.useDataValue({ viewPath,
context: 'resource',
path: 'preview_url',
})
let resourceContentTypeValueData = fromData.useDataValue({ viewPath,
context: 'resource',
path: 'content_type',
})
  return (<React.Fragment
>
<Video
  viewPath={`${viewPath}/Video`}
 data="resource.preview_url"
 src={resourcePreviewUrlValueData}
 data="resource.content_type"
 type={resourceContentTypeValueData}
 controls={true}
 crossOrigin="anonymous"
 width="100%"
/>
{children}
</React.Fragment>)
}